// ─── The display currency, remembered (sprint 13, 5.1) ──────────────────────
//
// Before this, `cur` lived in App's state only and every load started in
// dollars. Now:
//   • every device remembers the choice (localStorage, "si_cur");
//   • a registered user's choice is also kept in their profile
//     (profiles.display_currency, migrations/sprint13.sql), so it follows
//     them to another device. The profile wins over the device when both
//     have one. A guest's choice stays on the device.
//
// Until the column exists (David runs the SQL), reading and writing the
// profile fail with 42703 · both are quiet no-ops and the device copy keeps
// working. Nothing here throws.
import { supabase } from "../lib/supabase";
import { CURRENCIES } from "../constants/data";

const KEY = "si_cur";
const valid = c => typeof c === "string" && Object.prototype.hasOwnProperty.call(CURRENCIES, c);

export function readLocalCurrency() {
  try { const c = localStorage.getItem(KEY); return valid(c) ? c : null; } catch { return null; }
}
export function writeLocalCurrency(code) {
  if (!valid(code)) return;
  try { localStorage.setItem(KEY, code); } catch {}
}

export async function loadProfileCurrency(userId) {
  if (!supabase || !userId) return null;
  try {
    const { data, error } = await supabase.from("profiles").select("display_currency").eq("id", userId).maybeSingle();
    if (error) return null;
    return valid(data?.display_currency) ? data.display_currency : null;
  } catch { return null; }
}

export async function saveProfileCurrency(userId, code) {
  if (!supabase || !userId || !valid(code)) return false;
  try {
    const { error } = await supabase.from("profiles").update({ display_currency: code }).eq("id", userId);
    return !error;
  } catch { return false; }
}
